export enum ContentPerItem {
  Pagination = 9,
  Slider = 3,
  Review = 3
}
